const BASE_LOGIN_TEXT = {
  login_account: 'Login Account',
  email: 'Email',
  phone: 'Phone',
  forget_password: 'Forgot Password',
  login: 'Login',
  email_error: 'Email Error',
  password_error: 'Please enter a password of at least 8 characters',
  email_tips: 'Please enter your email',
  phone_tips: 'Please enter your phone',
  password_tips: 'Please enter a password of at least 8 characters',
  update_password_tips: 'Update password or register on a Viwoods device',
  return_login: 'Back',
  password_reqired: 'Password required',
  email_reqired: 'Email required',
  phone_reqired: 'Phone required',
  please_choose: 'Code',
  please_choose_area: 'Please choose area code',
  sms_login: 'Verification Code Login',
  password_login: 'Password Login',
  verification_tips: 'Please enter SMS code',
  enter_password_tips: 'Please enter your password',
  verification_code: 'Send',
  reSend: 'Resend',
  sending: 'Sending'
}

const LOGIN_LANGUAGE_OVERRIDES = {
  us: {},
  uk: {},
  zh: {
    login_account: '\u767b\u5f55\u8d26\u53f7',
    email: '\u90ae\u7bb1',
    phone: '\u624b\u673a',
    forget_password: '\u5fd8\u8bb0\u5bc6\u7801',
    login: '\u767b\u5f55',
    email_error: '\u90ae\u7bb1\u683c\u5f0f\u9519\u8bef',
    password_error: '\u8bf7\u8f93\u5165\u81f3\u5c11 8 \u4f4d\u5bc6\u7801',
    email_tips: '\u8bf7\u8f93\u5165\u60a8\u7684\u90ae\u7bb1',
    phone_tips: '\u8bf7\u8f93\u5165\u60a8\u7684\u624b\u673a\u53f7',
    password_tips: '\u8bf7\u8f93\u5165\u81f3\u5c11 8 \u4f4d\u5bc6\u7801',
    update_password_tips: '\u4fee\u6539\u5bc6\u7801\u6216\u6ce8\u518c\u9700\u5728 Viwoods \u8bbe\u5907\u4e0a\u64cd\u4f5c',
    return_login: '\u8fd4\u56de\u767b\u5f55',
    password_reqired: '\u5bc6\u7801\u5fc5\u586b',
    email_reqired: '\u90ae\u7bb1\u5fc5\u586b',
    phone_reqired: '\u624b\u673a\u53f7\u5fc5\u586b',
    please_choose: '\u533a\u53f7',
    please_choose_area: '\u8bf7\u9009\u62e9\u533a\u53f7',
    sms_login: '\u9a8c\u8bc1\u7801\u767b\u5f55',
    password_login: '\u5bc6\u7801\u767b\u5f55',
    verification_tips: '\u8bf7\u8f93\u5165\u77ed\u4fe1\u9a8c\u8bc1\u7801',
    enter_password_tips: '\u8bf7\u8f93\u5165\u60a8\u7684\u5bc6\u7801',
    verification_code: '\u53d1\u9001',
    reSend: '\u91cd\u53d1',
    sending: '\u53d1\u9001\u4e2d'
  },
  tw: {
    login_account: '\u767b\u5165\u5e33\u865f',
    email: '\u4fe1\u7bb1',
    phone: '\u624b\u6a5f',
    forget_password: '\u5fd8\u8a18\u5bc6\u78bc',
    login: '\u767b\u5165',
    email_error: '\u4fe1\u7bb1\u683c\u5f0f\u932f\u8aa4',
    password_error: '\u8acb\u8f38\u5165\u81f3\u5c11 8 \u4f4d\u5bc6\u78bc',
    email_tips: '\u8acb\u8f38\u5165\u60a8\u7684\u4fe1\u7bb1',
    phone_tips: '\u8acb\u8f38\u5165\u60a8\u7684\u624b\u6a5f\u865f',
    password_tips: '\u8acb\u8f38\u5165\u81f3\u5c11 8 \u4f4d\u5bc6\u78bc',
    update_password_tips: '\u4fee\u6539\u5bc6\u78bc\u6216\u8a3b\u518a\u9700\u5728 Viwoods \u8a2d\u5099\u4e0a\u64cd\u4f5c',
    return_login: '\u8fd4\u56de\u767b\u5165',
    password_reqired: '\u5bc6\u78bc\u5fc5\u586b',
    email_reqired: '\u4fe1\u7bb1\u5fc5\u586b',
    phone_reqired: '\u624b\u6a5f\u865f\u5fc5\u586b',
    please_choose: '\u5340\u865f',
    please_choose_area: '\u8acb\u9078\u64c7\u5340\u865f',
    sms_login: '\u9a57\u8b49\u78bc\u767b\u5165',
    password_login: '\u5bc6\u78bc\u767b\u5165',
    verification_tips: '\u8acb\u8f38\u5165\u7c21\u8a0a\u9a57\u8b49\u78bc',
    enter_password_tips: '\u8acb\u8f38\u5165\u60a8\u7684\u5bc6\u78bc',
    verification_code: '\u767c\u9001',
    reSend: '\u91cd\u65b0\u767c\u9001',
    sending: '\u767c\u9001\u4e2d'
  },
  nl: {
    login_account: 'Account aanmelden',
    email: 'E-mail',
    phone: 'Telefoon',
    forget_password: 'Wachtwoord vergeten',
    login: 'Aanmelden',
    email_error: 'E-mailfout',
    email_tips: 'Voer uw e-mail in',
    phone_tips: 'Voer uw telefoonnummer in',
    update_password_tips: 'Werk het wachtwoord bij of registreer op een Viwoods-apparaat',
    return_login: 'Terug',
    password_reqired: 'Wachtwoord verplicht',
    email_reqired: 'E-mail verplicht',
    phone_reqired: 'Telefoon verplicht',
    please_choose: 'Code',
    please_choose_area: 'Kies netnummer',
    sms_login: 'Inloggen met verificatiecode',
    password_login: 'Inloggen met wachtwoord',
    verification_tips: 'Voer de SMS-code in',
    enter_password_tips: 'Voer uw wachtwoord in',
    verification_code: 'Verstuur',
    reSend: 'Opnieuw verzenden',
    sending: 'Verzenden'
  },
  fr: {
    login_account: 'Compte de connexion',
    email: 'E-mail',
    phone: 'Telephone',
    forget_password: 'Mot de passe oublie',
    login: 'Connexion',
    email_error: 'Erreur e-mail',
    email_tips: 'Veuillez saisir votre e-mail',
    phone_tips: 'Veuillez saisir votre telephone',
    update_password_tips: 'Mettez a jour le mot de passe ou inscrivez-vous sur un appareil Viwoods',
    return_login: 'Retour',
    password_reqired: 'Mot de passe requis',
    email_reqired: 'E-mail requis',
    phone_reqired: 'Telephone requis',
    please_choose: 'Code',
    please_choose_area: 'Veuillez choisir lindicatif',
    sms_login: 'Connexion par code',
    password_login: 'Connexion par mot de passe',
    verification_tips: 'Veuillez saisir le code SMS',
    enter_password_tips: 'Veuillez saisir votre mot de passe',
    verification_code: 'Envoyer',
    reSend: 'Renvoyer',
    sending: 'Envoi'
  },
  de: {
    login_account: 'Konto anmelden',
    email: 'E-Mail',
    phone: 'Telefon',
    forget_password: 'Passwort vergessen',
    login: 'Anmelden',
    email_error: 'E-Mail-Fehler',
    email_tips: 'Bitte E-Mail eingeben',
    phone_tips: 'Bitte Telefonnummer eingeben',
    update_password_tips: 'Passwort aktualisieren oder auf einem Viwoods-Geraet registrieren',
    return_login: 'Zurueck',
    password_reqired: 'Passwort erforderlich',
    email_reqired: 'E-Mail erforderlich',
    phone_reqired: 'Telefon erforderlich',
    please_choose: 'Code',
    please_choose_area: 'Bitte Vorwahl waehlen',
    sms_login: 'Login mit Code',
    password_login: 'Login mit Passwort',
    verification_tips: 'Bitte SMS-Code eingeben',
    enter_password_tips: 'Bitte Passwort eingeben',
    verification_code: 'Senden',
    reSend: 'Erneut senden',
    sending: 'Senden'
  },
  it: {
    login_account: 'Account di accesso',
    email: 'Email',
    phone: 'Telefono',
    forget_password: 'Password dimenticata',
    login: 'Accedi',
    email_error: 'Errore email',
    email_tips: 'Inserisci la tua email',
    phone_tips: 'Inserisci il tuo telefono',
    update_password_tips: 'Aggiorna la password o registrati su un dispositivo Viwoods',
    return_login: 'Indietro',
    password_reqired: 'Password richiesta',
    email_reqired: 'Email richiesta',
    phone_reqired: 'Telefono richiesto',
    please_choose: 'Codice',
    please_choose_area: 'Scegli il prefisso',
    sms_login: 'Accesso con codice',
    password_login: 'Accesso con password',
    verification_tips: 'Inserisci il codice SMS',
    enter_password_tips: 'Inserisci la password',
    verification_code: 'Invia',
    reSend: 'Invia di nuovo',
    sending: 'Invio'
  },
  ja: {
    login_account: '\u30ed\u30b0\u30a4\u30f3\u30a2\u30ab\u30a6\u30f3\u30c8',
    email: '\u30e1\u30fc\u30eb',
    phone: '\u96fb\u8a71',
    forget_password: '\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5fd8\u308c\u305f',
    login: '\u30ed\u30b0\u30a4\u30f3',
    email_error: '\u30e1\u30fc\u30eb\u30a8\u30e9\u30fc',
    email_tips: '\u30e1\u30fc\u30eb\u3092\u5165\u529b',
    phone_tips: '\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b',
    update_password_tips: 'Viwoods \u30c7\u30d0\u30a4\u30b9\u3067\u30d1\u30b9\u30ef\u30fc\u30c9\u66f4\u65b0\u307e\u305f\u306f\u767b\u9332\u3057\u3066\u304f\u3060\u3055\u3044',
    return_login: '\u623b\u308b',
    password_reqired: '\u30d1\u30b9\u30ef\u30fc\u30c9\u5fc5\u9808',
    email_reqired: '\u30e1\u30fc\u30eb\u5fc5\u9808',
    phone_reqired: '\u96fb\u8a71\u5fc5\u9808',
    please_choose: '\u30b3\u30fc\u30c9',
    please_choose_area: '\u5730\u57df\u30b3\u30fc\u30c9\u3092\u9078\u629e',
    sms_login: '\u8a8d\u8a3c\u30b3\u30fc\u30c9\u30ed\u30b0\u30a4\u30f3',
    password_login: '\u30d1\u30b9\u30ef\u30fc\u30c9\u30ed\u30b0\u30a4\u30f3',
    verification_tips: 'SMS \u30b3\u30fc\u30c9\u3092\u5165\u529b',
    enter_password_tips: '\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5165\u529b',
    verification_code: '\u9001\u4fe1',
    reSend: '\u518d\u9001\u4fe1',
    sending: '\u9001\u4fe1\u4e2d'
  },
  ko: {
    login_account: '\ub85c\uadf8\uc778 \uacc4\uc815',
    email: '\uc774\uba54\uc77c',
    phone: '\uc804\ud654',
    forget_password: '\ube44\ubc00\ubc88\ud638 \ucc3e\uae30',
    login: '\ub85c\uadf8\uc778',
    email_error: '\uc774\uba54\uc77c \uc624\ub958',
    email_tips: '\uc774\uba54\uc77c\uc744 \uc785\ub825\ud558\uc138\uc694',
    phone_tips: '\uc804\ud654\ubc88\ud638\ub97c \uc785\ub825\ud558\uc138\uc694',
    update_password_tips: 'Viwoods \uae30\uae30\uc5d0\uc11c \ube44\ubc00\ubc88\ud638\ub97c \ubcc0\uacbd\ud558\uac70\ub098 \ub4f1\ub85d\ud558\uc138\uc694',
    return_login: '\ub4a4\ub85c',
    password_reqired: '\ube44\ubc00\ubc88\ud638 \ud544\uc218',
    email_reqired: '\uc774\uba54\uc77c \ud544\uc218',
    phone_reqired: '\uc804\ud654\ubc88\ud638 \ud544\uc218',
    please_choose: '\ucf54\ub4dc',
    please_choose_area: '\uad6d\uac00 \ubc88\ud638 \uc120\ud0dd',
    sms_login: '\uc778\uc99d\ucf54\ub4dc \ub85c\uadf8\uc778',
    password_login: '\ube44\ubc00\ubc88\ud638 \ub85c\uadf8\uc778',
    verification_tips: 'SMS \ucf54\ub4dc\ub97c \uc785\ub825\ud558\uc138\uc694',
    enter_password_tips: '\ube44\ubc00\ubc88\ud638\ub97c \uc785\ub825\ud558\uc138\uc694',
    verification_code: '\ubcf4\ub0b4\uae30',
    reSend: '\ub2e4\uc2dc \ubcf4\ub0b4\uae30',
    sending: '\ubcf4\ub0b4\ub294 \uc911'
  },
  pt: {
    login_account: 'Entrar na conta',
    email: 'E-mail',
    phone: 'Telefone',
    forget_password: 'Esqueceu a senha',
    login: 'Entrar',
    email_error: 'Erro de e-mail',
    email_tips: 'Digite seu e-mail',
    phone_tips: 'Digite seu telefone',
    update_password_tips: 'Atualize a senha ou registre-se em um dispositivo Viwoods',
    return_login: 'Voltar',
    password_reqired: 'Senha obrigatoria',
    email_reqired: 'E-mail obrigatorio',
    phone_reqired: 'Telefone obrigatorio',
    please_choose: 'Codigo',
    please_choose_area: 'Escolha o codigo de area',
    sms_login: 'Login com codigo',
    password_login: 'Login com senha',
    verification_tips: 'Digite o codigo SMS',
    enter_password_tips: 'Digite sua senha',
    verification_code: 'Enviar',
    reSend: 'Reenviar',
    sending: 'Enviando'
  },
  ru: {
    login_account: '\u0412\u0445\u043e\u0434 \u0432 \u0430\u043a\u043a\u0430\u0443\u043d\u0442',
    email: 'E-mail',
    phone: '\u0422\u0435\u043b\u0435\u0444\u043e\u043d',
    forget_password: '\u0417\u0430\u0431\u044b\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c',
    login: '\u0412\u043e\u0439\u0442\u0438',
    email_error: '\u041e\u0448\u0438\u0431\u043a\u0430 e-mail',
    email_tips: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail',
    phone_tips: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043b\u0435\u0444\u043e\u043d',
    update_password_tips: '\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c \u0438\u043b\u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044c \u043d\u0430 \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0435 Viwoods',
    return_login: '\u041d\u0430\u0437\u0430\u0434',
    password_reqired: '\u041f\u0430\u0440\u043e\u043b\u044c \u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u0435\u043d',
    email_reqired: 'E-mail \u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u0435\u043d',
    phone_reqired: '\u0422\u0435\u043b\u0435\u0444\u043e\u043d \u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u0435\u043d',
    please_choose: '\u041a\u043e\u0434',
    please_choose_area: '\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043e\u0434',
    sms_login: '\u0412\u0445\u043e\u0434 \u043f\u043e \u043a\u043e\u0434\u0443',
    password_login: '\u0412\u0445\u043e\u0434 \u043f\u043e \u043f\u0430\u0440\u043e\u043b\u044e',
    verification_tips: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 SMS-\u043a\u043e\u0434',
    enter_password_tips: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c',
    verification_code: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c',
    reSend: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0441\u043d\u043e\u0432\u0430',
    sending: '\u041e\u0442\u043f\u0440\u0430\u0432\u043a\u0430'
  },
  es: {
    login_account: 'Cuenta de inicio',
    email: 'Correo',
    phone: 'Telefono',
    forget_password: 'Olvide la contrasena',
    login: 'Iniciar sesion',
    email_error: 'Error de correo',
    email_tips: 'Introduce tu correo',
    phone_tips: 'Introduce tu telefono',
    update_password_tips: 'Actualiza la contrasena o registrate en un dispositivo Viwoods',
    return_login: 'Volver',
    password_reqired: 'Contrasena requerida',
    email_reqired: 'Correo requerido',
    phone_reqired: 'Telefono requerido',
    please_choose: 'Codigo',
    please_choose_area: 'Elige el codigo de area',
    sms_login: 'Inicio con codigo',
    password_login: 'Inicio con contrasena',
    verification_tips: 'Introduce el codigo SMS',
    enter_password_tips: 'Introduce tu contrasena',
    verification_code: 'Enviar',
    reSend: 'Reenviar',
    sending: 'Enviando'
  }
}

const loginLanguage = Object.keys(LOGIN_LANGUAGE_OVERRIDES).reduce((texts, language) => {
  texts[language] = Object.assign({}, BASE_LOGIN_TEXT, LOGIN_LANGUAGE_OVERRIDES[language])
  return texts
}, {})

export {
  loginLanguage
}
